import { render, staticRenderFns } from "./CBlockTitle.vue?vue&type=template&id=df967864&"
import script from "./CBlockTitle.vue?vue&type=script&lang=ts&"
export * from "./CBlockTitle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports